import { getDirectLoggedIn } from './login-index.reducer';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class RedirectService {
  private _redirect: string;
  set redirect(v: string) {
    this._redirect = v;
  }
  get redirect(): string {
    return this._redirect;
  }

  constructor(public store: Store<any>, private router: Router) {}

  public loginRedirect() {
    this.store.pipe(select(getDirectLoggedIn), take(1)).subscribe(loggedIn => {
      if (loggedIn && this._redirect) {
        if(localStorage.getItem('source')?.toLocaleLowerCase() === "ash"){
          localStorage.setItem('redirect', this._redirect);
         }
        this.router.navigateByUrl(this._redirect);
      }
      this.redirect = null;
    });
  }
}
